











 








const node = {
  "kind": "InlineDataFragment",
  "name": "useMeetingLocalState_meeting"
};

(node ).hash = "7647ed11f7209bdb2933a5a0a005b1de";

export default node;
